function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0-empty{fill-rule:evenodd;clip-rule:evenodd;fill:#FB735B;}\n\t.st1-empty{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2-empty{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3-empty{mask:url(#mask-2_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#121212;}\n\t.st4-empty{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st5-empty{mask:url(#mask-4_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#121212;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile-"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-127.000000, -334.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "img_to-do_empty",
  transform: "translate(127.000000, 334.000000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "picto_cloud",
  className: "st0-empty",
  d: "M88.5,43c-27.4,7.7-78-20.2-87.1,19.5c-9.1,39.8,26.7,67.2,60.7,65.4 c33.9-1.8,70.7-50.1,69.9-69.8C131.2,38.3,108.7,37.3,88.5,43"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(30.227273, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 0.5,
  y: 0.2,
  width: 63.4,
  height: 77.5
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 0.5,
  y: 0.2,
  width: 63.4,
  height: 77.5,
  id: "mask-2_1_"
}, /*#__PURE__*/React.createElement("g", {
  className: "st1-empty"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1_1_",
  className: "st2-empty",
  points: "0.5,0.2 63.9,0.2 63.9,77.7 0.5,77.7  "
}))), /*#__PURE__*/React.createElement("path", {
  id: "Fill-1",
  className: "st3-empty",
  d: "M6,69.6c-0.2,0.1-0.4,0.3-0.7,0.4c-0.4,1.2-0.8,2.4-1.1,3.5c0.1,0,0.2,0.1,0.3,0.1 c0.9-0.7,1.8-1.4,3-2.2C6.9,70.7,6.4,70.2,6,69.6 M9.8,52.8c-1.3,5-2.5,9.6-3.7,14.2c1.4,0.9,2.7,1.6,4.1,2.4 c2.9-2.3,6.3-4.1,9.1-6.9C16.1,59.2,13.1,56.1,9.8,52.8 M57.7,15c-1.5,1.5-2.6,2.7-3.8,3.9c-3,3.1-6.1,6.2-9.1,9.4 c-2.4,2.5-4.8,5-7.1,7.5c-2.4,2.6-4.7,5.4-7.2,8c-3.4,3.6-7,7.1-10.5,10.6c-0.8,0.8-1.5,1.6-2.3,2.5c1.5,1.2,2.5,2.7,4.5,3.2 c1.2-1.5,2.5-3.1,3.7-4.6c1.8-2.3,3.6-4.6,5.4-6.9c2.8-3.6,5.7-7.2,8.5-10.8c2-2.5,3.8-5.2,5.8-7.7c2.4-2.9,5.1-5.7,7.6-8.6 C54.9,19.8,56.5,17.8,57.7,15 M48.7,3.5C36,19.1,23.3,34.6,10.5,50.2c0.6,0.6,1.1,1.1,1.6,1.7c1.6-1.9,3.1-3.7,4.5-5.4 c5.2-6,10.5-11.9,15.8-17.9C37.3,23,42.1,17.3,47,11.8c1.2-1.4,2.6-2.6,3.9-3.9C51.5,7.3,51.5,6.6,51,6 C50.3,5.2,49.6,4.4,48.7,3.5 M53.7,9.6C40.3,24.2,27,38.7,13.8,53.1c0.9,1,1.7,1.9,2.6,2.8c13.1-14.7,26-29.1,39.1-43.8 C54.9,11.4,54.3,10.5,53.7,9.6 M23.9,61.3c0.3,0.9,1.5,1.5,0.8,2.6c-0.8,1.2-1.8,0.7-2.7,0.3C13.8,70.5,3.1,77.4,1.2,77.7 c-0.7-1-0.8-2.1-0.5-3.3c0.4-1.4,0.7-2.8,1.3-4c1.6-3.4,2-7.1,3.3-10.6c1.1-2.9,1.9-6,2.8-9c0.2-0.5,0.5-0.9,0.8-1.3 c1.3-1.7,2.6-3.5,3.9-5.2c2.7-3.7,5.4-7.5,8.2-11.2c3.8-4.9,7.7-9.8,11.5-14.7c1.4-1.8,2.8-3.5,4.1-5.3 c0.7-0.9,1.2-1.9,1.9-2.8c2.3-2.9,4.7-5.8,7.1-8.7c1.5-1.7,2.8-1.7,4.6-0.2c0.4,0.4,0.8,0.7,1.2,1.1c0.5,0.5,1,1.2,1.7,1.4 c0.5,0.2,1.2-0.5,1.8-0.6c0.5-0.1,1.2-0.1,1.4,0.2c0.3,0.4,0.5,1.1,0.4,1.6c-0.1,0.5-0.6,1-1,1.6c0.6,0.8,1.3,1.6,2,2.4 c0.2,0.2,0.6,0.4,0.9,0.5c2,0.4,2,0.4,1.6,2.4c0,0.1,0.1,0.3,0.1,0.6c0.6-0.3,1.1-0.6,1.7-0.8c0.4-0.1,1.2-0.2,1.4,0 c0.3,0.4,0.5,1.1,0.4,1.6c-0.3,1.1-0.8,2.3-1.3,3.3c-0.2,0.4-0.8,0.6-1.2,1c-0.8,0.7-1.8,1.2-2.4,2c-2.7,4-6.2,7.5-9.3,11.2 c-3,3.6-5.9,7.2-8.9,10.7c-3.3,3.9-6.7,7.7-10,11.6c-0.9,1-1.7,2.1-2.5,3.1C26.8,58,25.3,59.7,23.9,61.3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(0.000000, 12.954545)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter_1_",
  filterUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 40.1,
  height: 82
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 40.1,
  height: 82,
  id: "mask-4_1_"
}, /*#__PURE__*/React.createElement("g", {
  className: "st4-empty"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path-3_1_",
  className: "st2-empty",
  points: "0,0 40.1,0 40.1,82 0,82  "
}))), /*#__PURE__*/React.createElement("path", {
  id: "Fill-4",
  className: "st5-empty",
  d: "M16.2,76.6c0.4-1.6,0.8-3.1,1.2-4.7c0.8-3.1,1.7-6.3,2.5-9.4c0.3-1.3,0.7-2.6,1-3.9 c1.6-6,3.1-12,4.9-18c1.7-5.9,3.8-11.7,5.6-17.5c1.1-3.6,2.3-7.2,3.2-10.8c0.7-2.8,0.9-5.7,1.4-8.5c0.1-0.5,0.2-1,0.3-1.5 c0.4-1.4,1.5-1.9,2.8-2.2c0.8,0.5,1.2,1.2,0.9,2.2c-1.1,3.4-1,7-1.8,10.4c-1,4-2.3,7.8-3.5,11.7c-1,3.1-2,6.2-3,9.3 c-0.8,2.5-1.6,4.9-2.3,7.4c-1.2,4-2.2,8.1-3.3,12.1c-0.8,2.9-1.7,5.7-2.4,8.6c-1.5,5.7-2.8,11.4-4.3,17.1 c-0.1,0.6-0.3,1.1-0.5,1.7c-0.2,0.7-0.5,1.6-1.4,1.5c-0.8-0.1-1.8-0.3-2.2-0.8c-2.8-3.6-5.6-7.3-8.3-11.1 c-2-2.8-3.9-5.8-5.8-8.7C0.7,60.7,0.3,59.8,0,59c-0.1-0.2,0.2-0.7,0.4-0.9c0.1-0.1,0.6,0,0.8,0.1c0.4,0.4,0.8,0.9,1.2,1.3 c2.7,3.6,5.3,7.2,8,10.8c1.7,2.2,3.4,4.3,5.2,6.4C15.8,76.7,16,76.6,16.2,76.6"
})))))));

var SvgImgEmpty = function SvgImgEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132 128",
    style: {
      enableBackground: "new 0 0 132 128"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img_empty.73548b19.svg";
export { ForwardRef as ReactComponent };